import { render, staticRenderFns } from "./MosaicoPalavra.vue?vue&type=template&id=3282d012&scoped=true"
import script from "./MosaicoPalavra.vue?vue&type=script&lang=js"
export * from "./MosaicoPalavra.vue?vue&type=script&lang=js"
import style0 from "./MosaicoPalavra.vue?vue&type=style&index=0&id=3282d012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282d012",
  null
  
)

export default component.exports